export const DELETE_ARTEFACT_SUCCESS = "redux_store:artefacts.success.delete";
export const UPDATE_ARTEFACT_SUCCESS = "redux_store:artefacts.success.update";
export const ADD_ARTEFACT_SUCCESS = "redux_store:artefacts.success.post";


// WEBPACK FOOTER //
// ./src/successes/artefacts.js